export const TEXT_SIZES = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'4xl',
	'5xl',
	'6xl',
	'7xl',
	'8xl',
	'9xl',
] as const;

export type TextSize = typeof TEXT_SIZES[number];

export const TEXT_WEIGHTS = [
	{ value: 'thin', icon: 'lucide:type-bold' },
	{ value: 'extralight', icon: 'lucide:font-weight-extralight' },
	{ value: 'light', icon: 'lucide:font-weight-light' },
	{ value: 'normal', icon: 'lucide:font-weight-normal' },
	{ value: 'medium', icon: 'lucide:font-weight-medium' },
	{ value: 'semibold', icon: 'lucide:font-weight-semibold' },
	{ value: 'bold', icon: 'lucide:font-weight-bold' },
	{ value: 'extrabold', icon: 'lucide:font-weight-extrabold' },
	{ value: 'black', icon: 'lucide:font-weight-black' },
] as const;

export type TextWeight = typeof TEXT_WEIGHTS[number]['value'];

export const TEXT_ALIGNS = [
	{ value: 'start', icon: 'lucide:align-left' },
	{ value: 'center', icon: 'lucide:align-center' },
	{ value: 'end', icon: 'lucide:align-right' },
	{ value: 'justify', icon: 'lucide:align-justify' },
] as const;

export type TextAlign = typeof TEXT_ALIGNS[number]['value'];
